import { isAuthed, getEncodedToken, domain } from './getJWT';
import { getRedirectURL } from '../author/lib/authRedirect';
import getTenant from './getTenant';
import Cookies from 'universal-cookie';
import { updateJWT } from '../author/lib/useJWT';

const cookies = new Cookies();

const reauthPopup = () =>
  window.open(
    getRedirectURL(window.location.origin),
    `Token expired, please login again.`,
    'width=720,height=600,left=100,top=100'
  );

const REAUTH = 'reauth';

export const reauth = async () => {
  console.log(REAUTH);

  if (!isAuthed()) {
    reauthPopup();
    return;
  }

  try {
    const tenant = getTenant();
    const authBase = window.location.origin.includes('local')
      ? 'https://portal.vinciworks-dev.com'
      : window.location.origin.replace('authors.', 'portal.');

    // we cant use axios because we need to send content-type with no body, https://github.com/axios/axios/issues/86
    const response = await fetch(authBase + '/api/auth/v1/tokenextend', {
      method: 'POST',
      // omit credentials so the auth-header cookie isn't sent — it causes a 400
      credentials: 'omit',
      headers: {
        'Content-Type': 'application/json',
        accept: '*/*',
        Authorization: 'Bearer: ' + getEncodedToken(),
        'x-tenant-id': tenant
      }
    });

    const auth = response.headers.get('Authorization');

    // only write the cookie when we got a JWT back, otherwise we'd store "Bearer: null"
    if (auth) {
      cookies.set(`auth-header-${tenant}`, `Bearer: ${auth}`, {
        path: '/',
        domain
      });

      updateJWT();
    }
  } catch (e) {
    reauthPopup();
  }
};

window.reauth = reauth;
